import { menu } from './menu';
import { router } from './router';

export const NoveVozy = {
	menu,
	router,
};
